/**
 * "Re-read the Ask Dink status" signal (DNKADM-0461).
 *
 * `AskDinkLauncher` (top bar) reads `GET /v2/admin/assistant/status` once on mount. When an
 * owner flips the tenant switch in Settings, the screen calls {@link requestAssistantStatusRefresh}
 * after a successful save and the launcher, which subscribes while mounted, re-reads the status
 * so the button appears or disappears without a reload. A plain in-memory listener set: no
 * storage, no state library, and a no-op when nothing is mounted.
 */
const listeners = new Set<() => void>();

/** Subscribe to refresh requests; returns the unsubscribe function. */
export function onAssistantStatusRefresh(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Ask every mounted launcher to re-read the assistant status. */
export function requestAssistantStatusRefresh(): void {
  listeners.forEach((listener) => listener());
}
